export enum StepLoaderAnimationType {
	CENTER_TO_CORNER = 'centerToCorner',
	CORNER_IDLE = 'cornerIdle',
	CORNER_TO_CENTER = 'cornerToCenter',
	CENTER_LEFT_IDLE = 'centerLeftIdle'
}
